var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98828 12.7336L7.05495 14.3336C7.32161 14.6003 7.92161 14.7336 8.32161 14.7336H10.8549C11.6549 14.7336 12.5216 14.1336 12.7216 13.3336L14.3216 8.46697C14.6549 7.53364 14.0549 6.73364 13.0549 6.73364H10.3883C9.98828 6.73364 9.65495 6.4003 9.72161 5.93364L10.0549 3.8003C10.1883 3.2003 9.78828 2.53364 9.18828 2.33364C8.65495 2.13364 7.98828 2.4003 7.72161 2.8003L4.98828 6.86697",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58594 12.7336V6.20026C1.58594 5.26693 1.98594 4.93359 2.91927 4.93359H3.58594C4.51927 4.93359 4.91927 5.26693 4.91927 6.20026V12.7336C4.91927 13.6669 4.51927 14.0003 3.58594 14.0003H2.91927C1.98594 14.0003 1.58594 13.6669 1.58594 12.7336Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.09507d98004b2b938733625a921a406d.svg";
export { ForwardRef as ReactComponent };